import { newApiInstance } from 'functions/request';

export const fetchLists = () => newApiInstance.get('/my/filter_params');

export const addList = data => newApiInstance.post('/my/lists', data);

export const editList = ({ id, data }) => newApiInstance.put(`/my/lists/${id}`, data);

export const deleteList = id => newApiInstance.delete(`/my/lists/${id}`);
